import { AppModal } from 'shared/UI/UIKit/Modal';
import type { RoomModalProps } from '../../types';
import { RoomForm } from '../../../Form/ui/RoomForm';
import { useCopy } from '../model';
import { RoomModalFooter } from '../../Footer';

interface CopyRoomModalProps extends RoomModalProps {
  buildingId: number;
  onItemCopy: () => void;
}

export const CopyRoomModal = ({
  selectedRoom,
  visible,
  hide,
  buildingId,
  onItemCopy,
}: CopyRoomModalProps) => {
  const {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  } = useCopy({ hide, onItemCopy, buildingId, selectedRoom });

  const footer = <RoomModalFooter onSubmit={onSubmit} hideModal={hideModal} title="Создать" />;
  const content = <RoomForm form={form} />;

  return (
    <AppModal
      visible={visible}
      onCancel={hideModal}
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      maskClosable={false}
      title="Создать аудиторию"
    />
  );
};
